import React, { PropsWithChildren } from "react";
import classnames from "classnames";

import useLayoutStyles from './layout.style';
import { Header, HeaderProps, Sidebar, SidebarProps } from '../';

import { useLayoutState } from "../../../context";

export interface LayoutProps extends PropsWithChildren<any> {
  headerProps: HeaderProps,
  sidebarProps: SidebarProps,
}

export function Layout(props: LayoutProps) {
  const { 
    children,
    headerProps,
    sidebarProps
  } = props;

  var classes = useLayoutStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
        <>
          <Header
            {...headerProps}
          />
          <Sidebar
            {...sidebarProps}
          />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
            { children }
          </div>
        </>
    </div>
  );
}
